import React, { useState } from 'react';
import './Footer.css';
import {ReactComponent as TikTokIcon} from '../../assets/footer-icons/cv/tiktok-positive.svg'
import {ReactComponent as IgIcon} from '../../assets/footer-icons/cv/ig-neg.svg'
import TicTacToe from '../../components/game/TicTacToe';
import axios from 'axios'; // <-- 1. IMPORT AXIOS
import { useNotification } from '../../context/NotificationContext'; // <-- 2. IMPORT NOTIFICATION
import WhatsAppButton from '../common/WhatsAppButton';

function Footer() {
  const [email, setEmail] = useState('');
  const { showNotification } = useNotification(); // <-- 3. GET THE FUNCTION
  var seta = ">"
  // --- 4. THIS IS YOUR NEW SUBMIT FUNCTION ---
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Call your new API endpoint
      const response = await axios.post('/api/v1/subscribe-newsletter/', { email: email });

      // Use the 'message' from the server's response
      showNotification(response.data.message, 'success');
      setEmail(''); // Clear the input field

    } catch (err) {
      // Show any error from the server (e.g., "Already subscribed")
      showNotification(err.response.data.error || 'Already subscribed', 'error');
    }
  };
  // --- END NEW FUNCTION ---

  return (
    <footer>
      {/* (Your TicTacToe, Catalog, and For Buyers sections are unchanged) */}
      <div className='tic-tac-toe-container'>
        <TicTacToe />
      </div>
      <div className='catalog'>
        <ul>
          <li><h1>CATALOG</h1></li>
          <li><a href='/vintage'>Vintage</a></li>
          <li><a href='/clothing'>Clothing</a></li>
          <li><a href='/accessories'>Accessories</a></li>
          <li><a href='/re-clubbing'>Re-clubbing</a></li>
        </ul>
      </div>
      <div className='for-buyers'>
        <ul>
          <li><h1>FOR BUYERS</h1></li>
          <li><a href='/faq'>Delivery and Payment</a></li>
          <li><a href='/faq'>Return</a></li>
          <li><a href='/about'>About us </a></li>
        </ul>
      </div>

      {/* This form will now call the new handleSubmit */}
      <div className='subscribe'>
        <ul>
          <li>
            <h1>SUBSCRIBE TO NEWS</h1>
            <form className='newsletter-form' onSubmit={handleSubmit}>
              <input
                type='email'
                placeholder='Enter your email'
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button type='submit'>{seta}</button>
            </form>
          </li>
          <p>By clicking the button, you agree to the terms and conditions</p>
        </ul>
      </div>

      {/* (Your Contacts, Icons, and Vinis sections are unchanged) */}
      <div className='contacts'>
        <ul>
        <h1>CONTACTS</h1>
          <p>+34 642 348 827</p>
          <p>info@getinlinebrand.com</p>
        </ul>
      </div>
      <div className='icons'>
        <li>
          <a href='https://www.instagram.com/getinlinebrand/' aria-label='Instagram Link' target='_blank' rel='noopener noreferrer'>
            <IgIcon className="social-icon" />
          </a>
        </li>
        <li>
          <a href='https://www.tiktok.com/@getinlinebrand' aria-label='TikTok Link' fill='currentColor' target='_blank' rel='noopener noreferrer'>
            <TikTokIcon className="social-icon" />
          </a>
        </li>
        <li>
          <WhatsAppButton />
        </li>
      </div>
      <div className='vinis'>
        <ul>
          <li><p>Copyright © 2025. All rights reserved</p></li>
          <li><p>Boldly Unlocking Human-Made Algorithms - <strong>BUHMA</strong></p></li>
        </ul>
      </div>
    </footer>
  );
}

export default Footer;
